import { User } from "@/tracker-types";

interface ViewAsBannerProps {
  clientUser?: User | null;
  handleExitView: () => void;
  isMobile?: boolean;
}

export function ViewAsBanner({ clientUser, handleExitView, isMobile }: ViewAsBannerProps) {
  const name = clientUser?.firstName
    ? `${clientUser.firstName}${clientUser.lastName ? ` ${clientUser.lastName}` : ""}`
    : clientUser?.username || "Client";

  if (isMobile) {
    return (
      <div className="fixed top-0 left-0 right-0 z-50 bg-light-warning/90 dark:bg-dark-warning/90 text-light text-center text-xs py-2 font-bold backdrop-blur-sm">
        Viewing as{" "}
        <span className="inline-block max-w-[160px] truncate align-bottom font-bold">{name}</span>
        .{" "}
        <button onClick={handleExitView} className="underline ml-2">
          Exit
        </button>
      </div>
    );
  }
  return (
    <div className="w-full bg-light-warning/20 dark:bg-dark-warning/20 text-light-warning dark:text-dark-warning text-center text-xs py-1">
      Viewing as{" "}
      <span className="inline-block max-w-[200px] truncate align-bottom font-semibold">{name}</span>
      .{" "}
      <button onClick={handleExitView} className="underline font-bold">
        Exit View
      </button>
    </div>
  );
}
